lm.DOMReady(function () {
  if (document.getElementById("component-followingcommercialoperations")) {
    new lm.Composant('component-followingcommercialoperations');
  }
  if (document.getElementById("component-followingcommercialanimations")) {
    new lm.Composant('component-followingcommercialanimations');
  }
});